export default __webpack_public_path__ + "static/media/block-blue.04129183.svg";